// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://data.evee.ai";
const SUPABASE_FUNCTIONS_URL = "https://dqjtvrvhddcimnyxkdgb.supabase.co"; // Original project URL for edge functions
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRxanR2cnZoZGRjaW1ueXhrZGdiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTIwNjcyMDgsImV4cCI6MjA2NzY0MzIwOH0.Z94A4jEz8y3C2QJdwDJVMBPcYOioFg-0iXYUQ83aplM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Main client for database operations (uses custom domain)
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'sb-auth-token',
    flowType: 'pkce',
    detectSessionInUrl: true,
    debug: false
  }
});

// Separate client for edge functions (uses original project URL to avoid timeout issues)
export const supabaseFunctions = createClient<Database>(SUPABASE_FUNCTIONS_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'sb-auth-token',
    flowType: 'pkce',
    detectSessionInUrl: true,
    debug: false
  }
});